import { PlanProps } from 'shared/components/plan/plan';

export interface Product {
  id: string;
  features: ProductFeature[];
  plan: PlanProps;
}

export interface ProductFeature {
  id: string;
  name: string;
  description: string;
  isFeatured: boolean;
  isHidden: boolean;
  offeringType?: string;
  imagePath: string;
  status: ProductFeatureStatus;
  docsLink?: string;
}

export enum ProductFeatureStatus {
  AVAILABLE = 'available',
  CONTINUOUS_DEVELOPMENT = 'continuous-development',
  IN_DEVELOPMENT = 'in-development',
  NOT_PLANNED = 'not-planned',
  PARTIALLY_AVAILABLE = 'partially-available',
  PLANNED = 'planned',
}
